import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageNavbar from './LegalPageNavbar';
import './LandingPage.css';

const RefundPolicyPage = () => (
  <div className="landing-page">
    <LegalPageNavbar />

    <section className="section-container" style={{ paddingTop: '96px', paddingBottom: '72px' }}>
      <div className="section-content legal-document" style={{ maxWidth: 900 }}>
        <h1>Refund Policy</h1>
        <p><strong>Last updated:</strong> June 16, 2026</p>
        <p>
          This Refund Policy explains how refunds are handled for paid subscriptions and purchases on{' '}
          <strong>Syllera</strong> (Master Languages Vocabulary by Educational Level with AI-powered learning).
          By purchasing a subscription, you also agree to our{' '}
          <Link to="/terms-of-service">Terms of Service</Link>.
        </p>

        <h2>1. Subscription Plans</h2>
        <p>
          Syllera offers free and paid subscription plans. Paid plans provide access to premium features such as
          expanded course content, advanced learning tools, and personalized AI-powered study features. Pricing
          and billing cycles are displayed at checkout before you complete your purchase.
        </p>

        <h2>2. Free Trial</h2>
        <p>
          If a free trial is offered, you will not be charged until the trial period ends. You may cancel before
          the trial ends to avoid being charged. Trial terms are shown at signup or checkout.
        </p>

        <h2>3. Automatic Renewal</h2>
        <p>
          Subscriptions renew automatically at the end of each billing period unless you cancel before the renewal
          date. You are responsible for managing your subscription through your account settings or by contacting
          support.
        </p>

        <h2>4. Refund Eligibility</h2>
        <p>Refund requests are considered on a case-by-case basis. You may be eligible for a refund if:</p>
        <ul>
          <li>You were charged in error or charged twice for the same period</li>
          <li>You cancel within any refund window stated at checkout or in a promotional offer</li>
          <li>Technical issues on our side prevented meaningful use of the Platform for a sustained period</li>
          <li>Applicable consumer protection laws in your jurisdiction entitle you to a refund</li>
        </ul>
        <p>Refunds are generally <strong>not</strong> provided when:</p>
        <ul>
          <li>You simply changed your mind after substantial use of the Platform during the billing period</li>
          <li>Your account was suspended or terminated for violating our Terms of Service</li>
          <li>You failed to cancel before an automatic renewal and used the service after renewal</li>
        </ul>

        <h2>5. How to Request a Refund</h2>
        <p>
          To request a refund, contact <a href="mailto:support@syllera.com">support@syllera.com</a> within
          fourteen (14) days of the charge, including your account email, transaction date, and reason for the
          request. We will review and respond within a reasonable timeframe.
        </p>

        <h2>6. Processing Refunds</h2>
        <p>
          Approved refunds are returned to the original payment method where possible. Processing times depend
          on your bank or payment provider and may take 5–10 business days or longer. Partial refunds may be
          issued at Syllera&apos;s discretion based on usage during the billing period.
        </p>

        <h2>7. School and Institutional Purchases</h2>
        <p>
          Schools, businesses, and institutional accounts may be subject to separate agreements. Refund terms for
          those accounts are governed by the applicable contract or invoice terms.
        </p>

        <h2>8. App Store and Google Play Purchases</h2>
        <p>
          If you subscribed through the Apple App Store or Google Play Store, refunds must be requested through
          that store&apos;s refund process. Syllera cannot directly refund in-app purchases made via those
          platforms.
        </p>

        <h2>9. Changes to This Refund Policy</h2>
        <p>
          We may update this Refund Policy from time to time. Material changes will be posted on this page with
          an updated &quot;Last updated&quot; date.
        </p>

        <h2>10. Contact Us</h2>
        <p>For refund requests or billing questions, contact:</p>
        <ul>
          <li>Email: <a href="mailto:support@syllera.com">support@syllera.com</a></li>
          <li>Website: <Link to="/contact">syllera.com/contact</Link></li>
        </ul>
        <p>
          Related policies: <Link to="/terms-of-service">Terms of Service</Link> ·{' '}
          <Link to="/privacy-policy">Privacy Policy</Link>
        </p>
      </div>
    </section>
  </div>
);

export default RefundPolicyPage;
